import { DataGridWithCheckbox, type DataGridWithCheckboxProps } from '@shared/components';

export type BaseGrantAccessRoomDataGridProps = Omit<
  DataGridWithCheckboxProps,
  'rowHeight' | 'disableColumnMenu' | 'sx'
>;

export default function BaseGrantAccessRoomDataGrid(
  props: Readonly<BaseGrantAccessRoomDataGridProps>,
) {
  return (
    <DataGridWithCheckbox
      {...props}
      disableColumnMenu
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '.MuiButtonBase-root': {
          p: theme.spacing(0),
        },
        '.MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
          display: 'none',
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          px: theme.spacing(3),
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
